import { render, staticRenderFns } from "./BookingConfirmation.vue?vue&type=template&id=530b0b38&"
import script from "./BookingConfirmation.vue?vue&type=script&lang=js&"
export * from "./BookingConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./BookingConfirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('530b0b38')) {
      api.createRecord('530b0b38', component.options)
    } else {
      api.reload('530b0b38', component.options)
    }
    module.hot.accept("./BookingConfirmation.vue?vue&type=template&id=530b0b38&", function () {
      api.rerender('530b0b38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/BookingConfirmation.vue"
export default component.exports